import React from "react";

import { CreateApiHelperResponse } from "../utils/api-util";

const ApiContext = React.createContext<Partial<CreateApiHelperResponse>>({});

export const ApiProvider = ApiContext.Provider;
export default ApiContext;
